<template>
	<div class="h-full">
	<TopAppBar
	  :leftBtnMode="leftBtnMode"
	  :rightBtnMode="rightBtnMode"
	  :title="title"
	  :leftBtnMethod="leftBtnMethod"
	  :rightBtnMethod="rightBtnMethod"
	  staticMode="true"
	:hideCategory="true"
	></TopAppBar>
	<div class="d-flex h-full flex-column">
	<TopAppBarDrawer></TopAppBarDrawer>
		<main class="main-wrapper flex-grow-1">
			<div class="d-flex align-items-center bg-white">
				<div class="t-headline13 t-color-headlineBlack pda-14 flex-grow-1 bg-white fix-header-title d-flex align-items-center justify-content-center font-m">
					{{$t('3361')}}
				</div>
				<div class="mgr-24 right-button">
					<button type="button" class="mdc-button mdc-dialog__button" @click="goTOBAck" @keypress="goTOBAck"
					data-mdc-dialog-action="discard" tabindex="0">
					<div class="mdc-button__ripple"></div>
					<span class="mdc-button__label t-color-primary font-r t-body3">닫기</span>
				</button></div>
			</div>
			<div class="divider"></div>
			<!-- subtabs -->
		   
		   <div class="shadow2  fix-header-title-content">
			<div class="container container--narrow pdt-30 pdb-1">
				<div class="position-relative">
					<div class="t-center">
						<img :src="distributionDetail.member.profile.file.resourceUri" class="circle icon116 mgx-auto" alt="" v-if="distributionDetail.member && distributionDetail.member.profile && distributionDetail.member.profile.file.resourceUri">
						<div class="b-radius50 user-name-profile-116" v-html="getFirstLetter(distributionDetail.member.name)" :style="getRandomColor()" v-else></div>
						<div class="t-body1 l-spacing54 font-r t-center mgt-24">{{ distributionDetail.member.name.first || distributionDetail.member.name.last ?$t('3437',{first: distributionDetail.member.name.first, last: distributionDetail.member.name.last}):''}}</div>
						<div class="mgt-8">
							<span class="t-body3 font-r l-spacing42 t-line-h-20 t-color-bodyGrayA right-divider position-relative">{{distributionDetail.member.dutyName}}</span>
							<span class="t-body3 font-r l-spacing42 t-line-h-20 t-color-bodyGrayA right-divider position-relative">{{distributionDetail.member.responsibilityName}}</span>
						</div>
					</div>
				</div>
				<div class="pdl-24 pdr-24 pdt-16 pdb-16 mgt-32 b-radius4 checklist-user-info">
					<ul class="d-flex flex-wrap">
						<li><span class="t-body3 font-r t-color-bodyGrayB">{{$t('3362')}}</span> <span class="t-color-bodyGrayA font-r t-body2 pdl-8">{{$moment(distributionDetail.startDate).format('YYYY.MM.DD hh:mm')}}</span></li>
						<li><span class="t-body3 font-r t-color-bodyGrayB">{{$t('3363')}}</span> <span class="t-color-bodyGrayA font-r t-body2 pdl-8">{{distributionDetail.lastSubmitDate ? $moment(distributionDetail.lastSubmitDate).format('YYYY.MM.DD hh:mm') : ''}}</span></li>
						<li><span class="t-body3 font-r t-color-bodyGrayB">{{$t('3364')}}</span> <span class="t-color-bodyGrayA font-r t-body2 pdl-8">
							{{getDays >0 ? getDays+' days ': '' }}
					{{getHours >9 ? getHours : '0'+getHours}}:{{getMinutes > 9 ? getMinutes : '0'+getMinutes}}:{{getSeconds > 9 ? getSeconds : '0'+getSeconds}}</span></li>
					</ul>
				</div>
				<div class="mgt-16">
					<div class="check-list-result d-flex justify-content-between pdl-14 pdr-16 pdt-16 pdb-16 b-radius4">
						<div class="d-flex align-items-center">
							<div class="t-body1 t-color-contentBlue font-r t-line-h-20">{{$t('3366')}}</div>
							<div class="t-helper t-color-contentBlue font-r t-line-h-20 pdl-8">{{$t('3367')}} </div>
						</div>
						<div class="t-headline3 font-rb t-color-contentBlue">{{distributionDetail.totalScore ? distributionDetail.totalScore : 0}}</div>
					</div>
				</div>
				<div class="mgt-32"  v-if="distributionDetail.activeRespondentPaper && distributionDetail.activeRespondentPaper.groups.length > 0">
					<div class="mdc-card mgb-16" v-for="(myData, index) in distributionDetail.activeRespondentPaper.groups" :key="index+myData.id">
						<div class="d-flex align-items-center justify-content-between pdt-4 pdb-4 pdl-16 pdr-16">
							<div class="t-subtitle3 font-m flex-grow-1">{{myData.name}}</div>
							<button class="mdc-icon-button content-trigger mgr--16">
								<i v-if="index > 0"
									class="material-icons t-headline12 t-color-bodyGrayA">keyboard_arrow_down</i>
									<i v-else
									class="material-icons t-headline12 t-color-bodyGrayA">keyboard_arrow_up</i>
									</button>
						</div>
						<div class="detail-content" :class="index > 0 ? 'd-none' : ''">
							<div class="divider"></div>
							<div class="pdt-12 pdb-12 pdl-24 pdr-24">
								<div v-for="(innerData, indexInner) in myData.questions" :key="indexInner">
							   <div class="qa-wrapper pdt-16 pdb-16">
									<div class="q-wrapper">
										<div class="d-flex">
											<div class="t-subtitle2 font-b t-nowrap">Q{{indexInner+1}}.</div>
											<div class="flex-grow-1 pdl-4">
												 <span class="t-body1 font-r  l-spacing42">{{innerData.question.contents}}?</span>
												 <span class="t-body3 t-color-bodyGrayA  pdl-2 l-spacing42">{{$t('3368', {str1:innerData.answerScore, str2: innerData.question.score})}}</span>
											</div>
										</div>
									</div>
									<div class="a-wrapper pdt-11">
										<span class="t-subtitle2 font-b t-color-contentVariationInactive">A{{indexInner+1}}.</span>
																			<span class="t-body3 font-r l-spacing42 pdl-4 t-color-bodyGrayA" v-if="innerData.type == 'CHOICE_SINGLE'">
										<span v-for="(choiceData) in innerData.choices" :key="choiceData.answerChoice.id">
										{{choiceData.weight == 1 ? choiceData.answerChoice.contents :''}}
										</span>
									</span>
											<span class="t-body3 font-r l-spacing42 pdl-4 t-color-bodyGrayA" v-if="innerData.type == 'CHOICE_WORKS'">
										<span v-for="(WorkData, workIndex) in innerData.works"  :key="WorkData.member.id">
										{{ WorkData.member ? $t('3437',{first: WorkData.member.first, last: WorkData.member.last}):''}}{{workIndex+1 == innerData.works.length ? '': ','}}
										</span>
									</span>
									<span class="t-body3 font-r l-spacing42 pdl-4 t-color-bodyGrayA" v-if="innerData.questionTextReply">{{innerData.questionTextReply}}</span>
																		<div class="mgt-17 pda-16 bg-documentGray b-radius4" v-if="innerData.comment">
										<div class="t-body3 font-r l-spacing42">{{$t('3369')}}</div>
										<div class="t-body3 font-r l-spacing42 t-color-bodyGrayA mgt-12">
											{{innerData.comment}}</div>
									 </div>
									 <div class="mgt-8 pda-16 bg-documentGray b-radius4" v-if="innerData.image && innerData.image.resourceUri">
										<div class="t-body3 font-r l-spacing42">{{$t('3370')}}</div>
										<div class="t-body3 font-r l-spacing42 t-color-bodyGrayA mgt-12"><img :src="innerData.image.resourceUri" @click="showImage(innerData.image.resourceUri)" @keypress="showImage(innerData.image.resourceUri)" alt="" class="chcklist-ans-image b-radius4" tabindex="0"></div>
									 </div>
									
									</div>
							   </div>

							</div>
							   
							   
								</div>
							</div>
						</div>
					
				</div>
				
			</div>
		   </div>
			<div class="bg-documentGray mgt-2 pdb-34" v-if="comments && comments.length>0">
				<div class="container container--narrow pdt-16">
					<div class="flex-coloumn"  v-for="comment in comments" :key="comment.id">
						<div class="d-flex mgb-16">
							<div class="list-image-small mgt-16"  v-if="comment && comment.auditor && comment.auditor.register && comment.auditor.register.profile">
								<img v-if="comment && comment.auditor && comment.auditor.register" :src="comment && comment.auditor && comment.auditor.register && comment.auditor.register.profile? comment.auditor.register.profile:'/images/board/user-icon.png'" class="circle icon52" alt="">
							</div>
							<div v-else v-html="firstCharOfNames" :style="bgColorOfName" class="list-image-small circle w-40 min-w-40 h-40 user-name-profile"></div>
							<div class="d-flex flex-row-reverse w-full">
								<div class="pdl-16  position-relative mdc-menu-anchor menu-container cursor-pointer header-toggle more-btn-parent-div">
									<i class="material-icons mdc-icon-button t-headline6 js--dropdown-toggle t-color-iconInactive" @click="toggleMore" @keypress="toggleMore">more_horiz</i>
									<div class="mdc-menu mdc-menu-surface toggle-menu more_box">
										<ul class="mdc-list mdc-ripple-upgraded" role="menu" aria-hidden="true" aria-orientation="vertical" tabindex="-1">
											<li class="mdc-list-item mdc-ripple-upgraded" role="menuitem" tabindex="-1" @click="reportComment(comment.id, comment.report)" @keypress="reportComment(comment.id, comment.report)" v-if="!comment.owner">
												<span class="mdc-list-item__ripple"></span>
												<span class="mdc-list-item__text t-body6 font-r">{{ $t("3136") }}</span>
											</li>
											<li class="mdc-list-item mdc-ripple-upgraded" role="menuitem" tabindex="0" v-if="comment.owner"
									@click="editCommentSet(comment,$event)" @keypress="editCommentSet(comment,$event)">
												<span class="mdc-list-item__ripple"></span>
												<span class="mdc-list-item__text t-body6 font-r">{{ $t("3137") }}</span>
											</li>
										<li class="mdc-list-item mdc-ripple-upgraded" role="menuitem" tabindex="0" v-if="comment.owner"
									@click="deleteComment(comment.id,0,$event)" @keypress="deleteComment(comment.id,0,$event)">
												<span class="mdc-list-item__ripple"></span>
												<span class="mdc-list-item__text t-body6 font-r">{{ $t("3138") }}</span>
											</li>
										</ul>
									</div>
								</div>
								<div class="flex-grow-1  mgt-16">
									<div class="d-flex justify-content-between pdl-16">
										<div class="t-body1 mgb-1 font-r mgb-4">{{ comment && comment.auditor && comment.auditor.register && comment.auditor.register.name ? $t('3437',{first: comment.auditor.register.name.first, last: comment.auditor.register.name.last}):''}}</div>
									</div>

									<div class="t-body3 font-r t-color-bodyGrayA  pdl-16">{{ $moment(comment.auditor.register.time).format("L") }}</div>
									<div class="t-body6 font-r t-color-bodyGrayA mgt-16 l-spacing45 t-line-h-25  pdl-16" v-html="comment.contents">
									</div>
									<div class="d-flex flex-wrap pdl-16 mgt-16 mgr--60" v-if="comment && comment.images && comment.images.length">
										<div class="square-image attached-image" v-for="(img, i) in comment.images" :key="i" @click="fileDisply(img)" @keypress="fileDisply(img)">
											<img  @click="fileDisply(img.resourceUri,false)" @keypress="fileDisply(img.resourceUri,false)" v-if="getType(img.contentType) === 'image'" :src="img.resourceUri" :alt="img.originalName" tabindex="0"/>
																			<video-player
									class="video-player-box comment-video"
									v-if="getType(img.contentType) === 'video'"
									ref="videoPlayer"
									:options="getPayerOption(img)"
									:playsinline="true"
									customEventName="customstatechangedeventname"
								/>
								<div style="position:absolute; background-color:transparent; width:80px;height:80px; margin-top: 80px;z-index:999"></div>
										</div>
									</div>
									<div class="mgt-8 mgl-16 t-color-iconInactive font-r t-body3 l-spacing42"  tabindex="0" @click="toggleReply(comment.id,comment.auditor.register.name.fullName)" @keypress="toggleReply(comment.id,comment.auditor.register.name.fullName)">{{$t('3135')}}</div>
									<input type="hidden" id="replyCommentId" />         
					   <div class="d-grid flex-column d-none" :id="`commentInput_${comment.id}`">
								</div>
							</div>
						</div>
						</div>
						<!-- reply -->
						<div class="mgl-50 pdl-16 reply-comment-container d-flex flex-column">
							<div class="d-flex mgb-16" v-for="reply in comment.children" :key="reply.id">
								<div class="list-image-small mgt-16 w-auto min-w-auto" v-if="reply && reply.auditor && reply.auditor.register && reply.auditor.register.profile">
									<img :src="reply && reply.auditor && reply.auditor.register && reply.auditor.register.profile? reply.auditor.register.profile:'/images/board/user-icon.png'" class="circle w-40 h-40" alt="">
								</div>
								<div class="list-image-small user_img w-28 min-w-28 h-28 user-name-profile reply" v-else v-html="firstCharOfNames" :style="bgColorOfName"></div>
								<div class="d-flex flex-row-reverse w-full">
									<div class="pdl-16  position-relative mdc-menu-anchor menu-container more-btn-parent-div cursor-pointer header-toggle" v-if="!reply.owner || (selectedChild && selectedChild.modify === true) ||  (selectedChild && selectedChild.remove === true) ">
										<i class="material-icons mdc-icon-button t-headline6 js--dropdown-toggle t-color-iconInactive" tabindex="0" @click="toggleMore" @keypress="toggleMore">more_horiz</i>
										<div class="mdc-menu mdc-menu-surface toggle-menu more_box" >
											<ul class="mdc-list mdc-ripple-upgraded" role="menu" aria-hidden="true" aria-orientation="vertical" tabindex="0">
												<li class="mdc-list-item mdc-ripple-upgraded" role="menuitem" tabindex="0" 								
															v-if="!reply.owner"
											@click="reportComment(reply.id, reply.report)" @keypress="reportComment(reply.id, reply.report)">
													<span class="mdc-list-item__ripple"></span>
													<span class="mdc-list-item__text t-body6 font-r">{{ $t("3136") }}</span>
												</li>
												<li class="mdc-list-item mdc-ripple-upgraded" role="menuitem" tabindex="0"
												v-if="reply.owner"
											@click="editReplySet(reply,comment.id,$event,comment.auditor.register.name.fullName)" @keypress="editReplySet(reply,comment.id,$event,comment.auditor.register.name.fullName)">
													<span class="mdc-list-item__ripple"></span>
													<span class="mdc-list-item__text t-body6 font-r">{{ $t("3137") }}</span>
												</li>
																								<li class="mdc-list-item mdc-ripple-upgraded" role="menuitem" tabindex="0"
												v-if="reply.owner"
												@click="deleteComment(reply.id,comment.id,$event)" @keypress="deleteComment(reply.id,comment.id,$event)">
													<span class="mdc-list-item__ripple"></span>
													<span class="mdc-list-item__text t-body6 font-r">{{ $t("3138") }}</span>
												</li>
											</ul>
										</div>
									</div>
									<div class="flex-grow-1  mgt-16">
										<div class="d-flex justify-content-between pdl-16">
											<div class="t-body1 mgb-1 font-r mgb-4">{{ reply.auditor.register.name?$t('3437',{first: reply.auditor.register.name.first, last: reply.auditor.register.name.last}):'' }}</div>
										</div>

										<div class="t-body3 font-r t-color-bodyGrayA  pdl-16">{{ $moment(reply.auditor.register.time).format("L") }}</div>
										<div class="t-body6 font-r t-color-bodyGrayA mgt-16 l-spacing45 t-line-h-25  pdl-16" v-html="reply.contents">
											
										</div>
										<div class="d-flex flex-wrap pdl-16 mgt-16 mgr--64" v-if="reply && reply.images && reply.images.length">
											<div class="square-image attached-image" v-for="(img, l) in reply.images" :key="l" @click="fileDisply(img)" @keypress="fileDisply(img)" tabindex="0">
												<img v-if="getType(img.contentType) === 'image'" :src="img.resourceUri" :alt="img.originalName">
											<video-player
											class="video-player-box comment-video"
											v-if="getType(img.contentType) === 'video'"
											:options="getPayerOption(img)"
											:playsinline="true"
										/>
										<div style="position:absolute; background-color:transparent; width:80px;height:80px; top: 0;z-index:999"></div>
											</div>

										</div>
										<!-- <div class="mgt-8 mgl-16 t-color-iconInactive font-r t-body3 l-spacing42">답글 달기</div> -->
									</div>
								</div>
							</div>

					</div>

				</div>
			</div>
			</div>
			<div class="bg-documentGray mgt-2" v-else>
				<div class="container container--narrow pdt-50 pdb-50"><div class="t-body3 font-r l-spacing42 t-line-h-24 t-color-bodyGrayB t-center">체크리스트 결과에 대해 코멘트를 작성할 수 있습니다.</div></div>
			</div>
		</main>
		<div class="footer bg-white">
			<div class="divider"></div>
			<div class="container container--narrow comment-write">
				<div class="d-flex align-items-center justify-content-between pdt-16 pdb-15">
					<div class="d-flex flex-grow-1 position-relative">
						
						<textarea rows="1"  
						@keyup="resizeIt($event.target.value)"
						@blur="setInactive"
							@click="setActive"
							@keypress="setActive"
							tabindex="0"
							:class="{'commentInvaliderror':commentValid}"
							v-model="form.contents"
							:placeholder="$t('3134')"
							id="comment_textarea"
							class="cursor-blue comment_textarea mdc-text-field__input t-body6 font-r l-spacing42 pdr-16 t-color-headlineBlack t-line-h-25"></textarea>
					</div>
				</div>
						<div class="attachedFileContainer scroll-x d-flex"   v-if="form.images.length >0" >								
									<div class="post-video position-relative pdr-12 attach-video pdt-12 w-80 h-80 mgr-4" v-for="(img, i) in form.images" :key="i" >
											<img :src="img.resourceUri" :alt="img.originalName"  v-if="getType(img.contentType) == 'image' " class="b-radius4 w-80 h-80 "/>
											<video-player
											v-if="getType(img.contentType) == 'video'"
											class="video-player-box  attach-video"
											:options="{muted: true, language: 'en', playbackRates: [0.7, 1.0, 1.5, 2.0], sources: [{type: img.contentType, src: img.resourceUri }], height: 100, width:100}"
											:playsinline="true"
									/>
											<span tabindex="0" @click="form.images.splice(i, 1)" @keypress="form.images.splice(i, 1)" class="remove-img remove-image-new position-absolute t-color-white remove-image-new-checlist"><img src="/images/close.svg" class="w-20 h-20" /></span>
									</div>
	     </div>

				<div class="d-flex  pdt-4 pdb-4">
					<div class="d-flex flex-grow-1 position-relative align-items-center justify-content-between">
						<input
									type="file"
									id="commentFileUpload"
									accept="image/jpeg, image/png, video/mp4"
									@change="uploadFile"
									class="d-none"
							/>
						<button class="material-icons mdc-icon-button sendUploadBtn mgl--12 t-color-iconInactive" @click="openFileUpload(true)" @keypress="openFileUpload(true)" tabindex="0">collections</button>
						<button
							class="mdc-icon-button  sendMessageBtn t-color-white align-items-center justify-content-between mgr--12"><i
								class="material-icons  min-w-24 min-h-24 " :class="coomentActiveButton ?'bg-iconActive':'bg-iconInactive'" @click="submitComment" @keypress="submitComment">arrow_upward</i></button>
					</div>
				</div>
			</div>
		</div>
	</div>
	</div>
</template>

<script>
import {MDCMenu} from '@material/menu';
import checklistApi from '@/api/checklistApi.js'
import TopAppBarDrawer from "../TopAppBarDrawer.vue";
import { topAppBarMixin } from "../../mixins/topAppBar.js";
import InfiniteLoading from 'vue-infinite-loading'
import TopAppBar from "@/components/TopAppBar.vue";
import ImagePreview from './preview/imagePreview.vue';
export default {
	data() {
		return {
			coomentActiveButton:false,
			menuBar: null,
			detail: [],
			distributionDetail: null,
			contents:'',
			isNoData: false,
			showImagePreview:false,
			previewimageUrl:null,
			getMinutes : 0,
			getHours : 0,
			getDays : 0,
			getSeconds:0,
			isComment: true,
			commentValid:false,
			commentEdit:false,
			commentEditId:null,
			selectedChild:null,
			comments:[],
			replyImg: [],
			currentPage: 1,
			totalPages: 1,
			form: {
				contents: null,
				images: [],
			},
						b :true,
			userName: '',
			evtReply:{},
			commentBottom: true,
			firstCharOfNames : localStorage.getItem('firstChar'),
			bgColorOfName : localStorage.getItem('bgColors'),
		}
	},

	components: {
		TopAppBarDrawer,
		InfiniteLoading,
		TopAppBar,
		ImagePreview
	},

	mixins: [topAppBarMixin],

	watch: {
		$route(to, from) {
			this.initData()
		}
	},
	
	mounted() {

		this.distributionId =  this.$route.params.postId;
		
		this.getDetail();
		this.getComments();
	},

	methods: {
		setActive(){
			this.coomentActiveButton = true;
		},
		setInactive(){
			if(this.form.contents == null || this.form.contents.length == 0){
				this.coomentActiveButton = false;
			}
		},
		fileDisply(data) {
			// localStorage.setItem("socialFile", JSON.stringify(data));
			// this.$router.push({
			// 	name: 'PerviewFile',
			// 	params: this.$route.params,
			// 	query: this.$route.query
			// })
		},
				// Open menu report,modify and delete
		toggleMore(evt) {
			let field = evt.target.closest(".more-btn-parent-div").querySelector(".more_box");
			// if(field.classList.contains('mdc-menu-surface--open')){
			// 	field.classList.remove("mdc-menu-surface--open");
			// }
			// else{
				field.classList.toggle("mdc-menu-surface--open");
		//	}
		},
				deleteComment(id,pid,evt) {
			// console.log(id,pid,evt)
			 this.toggleMore(evt)
			this.$showLoading();
				checklistApi.deleteComment(this.$route.params, id).then((response) => {
				this.$hideLoading();
			//	console.log(this.detail, this.comments)
				if(pid>0){
					for (let c in this.comments) {
					if (this.comments[c].id == pid) {
						for (let r in this.comments[c].children) {
						if (this.comments[c].children[r].id == id) {
							this.comments[c].children.splice(r, 1);
							return;
						}
						}
						return;
					}
					}
				}else{
					for (let c in this.comments) {
					if (this.comments[c].id == id) {
						this.comments.splice(c, 1);
						return;
					}
					}
				}

			}).catch((err) => {
				this.$error({ content: err.errMsg }).then(() => {});
			});
		},
		editCommentSet(comment,evt){
			this.commentBottom = true;
			this.userName ='';
			this.replyEditId ='';
			this.replyEdit      = false;
			this.form.contents = comment.contents;
			this.form.images   =  comment.images;
			this.commentEditId = comment.id;
			this.commentEdit = true;
			this.toggleMore(evt)
		},
	editReplySet(reply,cid,evt,userId){
			this.commentEditId='';
			this.commentEdit = false;
			this.commentBottom = false;
			this.form.contents  = reply.contents;
			this.form.images    = reply.images;
			this.replyEditId    = reply.id;
			this.replyEdit      = true;
			this.toggleMore(evt)
			this.toggleReply(cid,userId)
		},
	toggleReply(commentId,userId) {
			this.commentBottom=false
			this.userName = userId
			this.b = !this.b;
			let comeId= document.getElementById('replyCommentId').value = commentId;
			if(comeId && this.b===false) {
				this.userName
			} else {
				this.userName = ''
			}
			document.getElementById(`commentInput_${commentId}`).classList.toggle("d-none");
		},

		getComments() {
			let responseData = null;
			let params = this.setParams();
				checklistApi.listComments(this.$route.params,params).then((response) => {
					responseData = response.data.data;
					this.comments = this.comments.concat(responseData.content);
				//this.comments = responseData.content;
					this.currentPage++;
					this.totalPages = responseData.totalPages;
				})
				.catch((err) => {
				});
			},
		goTOBAck(){
			if(this.$route.query.checkId){
			this.$router.push({
				name: 'CheckListView',
				params: {postId:this.$route.query.checkId},
			})
			}
			else{
				this.$router.go(-1);
			}
		},
		setParams() {
			let params = {
				page:this.currentPage,
				size: 10,
			};
			return params;
		},
		addClass() {
			document.getElementById('video-list').classList.add('showList')
		},
		removeClass() {
			document.getElementById('video-list').classList.remove('showList')
		},
  myTriggerFunc(){
					if (document.querySelectorAll(".content-trigger")) {
			var contentTrigger = Array.from(document.querySelectorAll(".content-trigger"));
			contentTrigger.forEach((item) => {
				item.addEventListener("click", function () {
					if ((this.firstChild.innerHTML) === 'keyboard_arrow_down') {
						this.firstChild.innerHTML = 'keyboard_arrow_up'
					} else {
						this.firstChild.innerHTML = 'keyboard_arrow_down'
					}
					this.parentNode.nextElementSibling.classList.toggle("d-none")

				});
			})
		}
		},
		getDetail() {
			this.$showLoading();
			checklistApi.submitCheckListDetails(this.$route.params).then((response) => {
				this.distributionDetail = response.data.data;
			//	var seconds = (this.distributionDetail.lastSubmitDate.getTime() - this.distributionDetail.startDate.getTime()) / 1000;
			this.getSeconds = this.$moment(this.distributionDetail.lastSubmitDate).diff(this.$moment(this.distributionDetail.startDate), 'seconds')%60;
			this.getMinutes = this.$moment(this.distributionDetail.lastSubmitDate).diff(this.$moment(this.distributionDetail.startDate), 'minutes');
			if( this.getMinutes > 59 && this.getMinutes < 1440){
				this.getHours = Math.trunc( this.getMinutes/60 );
				this.getMinutes = this.getMinutes%60;
			}
			else if(this.getMinutes >= 1440){
					this.getHours = Math.trunc(this.getMinutes/60);
				 if(this.getHours >=24){
						this.getDays = Math.trunc( this.getHours/24 );
						this.getHours = this.getHours%24;
					}
					this.getMinutes = this.getMinutes%60;
			}
			//	this.$moment(this.distributionDetail.startDate)
				this.$hideLoading();
				setTimeout(()=>{
				this.myTriggerFunc();
				},0)
			}).catch((err) => {
				this.$hideLoading();
				this.$error({ content: err.errMsg }).then(() => {});
			});
		},


		askForModify() {
			this.$router.push({
				name: 'BoardModify',
				params: {boardId:this.$route.params.boardId,postId:this.$route.params.postId},
				query: this.$route.query
			})
		},
    getFirstLetter(name) {
      let firstCharOfName = name.fullName.trim().slice(0,1);
      //localStorage.setItem('firstChar', firstCharOfName)
      return firstCharOfName;
    },
      
    getRandomColor(){
        let colors = ['#fb6262', '#d16443d4', '#4d9fd6', '#40bca7', '#9db82f','#76a0d6', '#a967d4', '#696481', '#4c438d', '#fe7947'];
        let randomColor = colors[Math.floor(Math.random() * colors.length)];
        //localStorage.setItem('bgColors', `background-color:${randomColor}`)
        return `background-color:${randomColor}`
    },
		moveToQuestion() {
			this.$router.push({
				name: 'CheckListQuestionTake',
				params: {postId:this.$route.params.postId}
			})
		},
  showImage(imageUrlData){
			this.showImagePreview = true;
			this.previewimageUrl = imageUrlData;
		},
		closePreview(){
				this.showImagePreview = false;
			this.previewimageUrl = null;
		},
		goToPrevious() {
			if(this.$route.query && this.$route.query.fromPage=='main') {
				this.$router.push('/home')
			} else {
				this.$router.push('/board/'+this.$route.params.boardId+'?boardName='+encodeURI(this.$route.query.boardName)+'&categoryName='+encodeURI(this.$route.query.categoryName))
			}
		},
				// Submit Comment
		submitComment() {
			if(this.b===true) {
				if((this.form.contents && this.form.contents.length > 0) || (this.form && this.form.images.length > 0)){
					this.commentValid = false;
					//this.userAuth();
					this.$showLoading();
					if(this.commentEdit){
							checklistApi.commentEdit(this.$route.params, this.form,this.commentEditId).then((resp) => {
							// reset comment form
							this.resetCommentForm();
							//this.comments.push(resp.data.data);
							let commentIndex = this.comments.findIndex((el) => el.id == resp.data.data.id);
							this.comments[commentIndex] = resp.data.data;
							this.commentEdit = false;
							//this.detail.commentCount = this.detail.commentCount + 1;
							this.$hideLoading();
						}).catch((err) => {
							this.$error({ content: err.errMsg }).then(() => {});
						});
					}else{
							checklistApi.commentPost(this.$route.params, this.form).then((resp) => {
								// reset comment form
								this.resetCommentForm();
								this.comments.push(resp.data.data);
								
								this.$hideLoading();
							})
							.catch((err) => {
							this.$error({ content: err.errMsg }).then(() => {});
							});
					}
		
				}else{
					this.commentValid = true;
				}

			} else {
				let commentId =  document.getElementById('replyCommentId').value;
				this.submitReply(commentId)
			}
		},
				// Submit Reply comment
		submitReply(originId) {
				this.$showLoading();
					if(!this.replyEdit){
						//if(this.userAuthData.userCommToDayAuth){
						// call API to add reply
							checklistApi.postReply(this.$route.params, originId, this.form).then((response) => { 
								this.$hideLoading();
								//evt.target.closest(".reply_area").querySelector(".comment_textarea").value = null;
								this.resetCommentForm();
								this.toggleReply(originId);
								this.replyImg = [];
								//this.getDetail();
								this.getComments();
								this.userName='';
								// add reply into parent
								for (let c in this.comments) {
									if (this.comments[c].id == originId) {
									this.comments[c].children.push(response.data.data);
									}
								}
							}).catch((err) => {
								this.$error({ content: err.errMsg }).then(() => {});
							});
					} else {
						checklistApi.editReply(this.$route.params,this.replyEditId, this.form).then((response) => {
							this.$hideLoading();
							//evt.target.closest(".reply_area").querySelector(".comment_textarea").value = null;
							this.resetCommentForm();
							this.toggleReply(originId);
							this.replyImg = [];
							this.replyEdit = false;
							this.getComments();
							this.userName='';
							// add reply into parent
							for (let c in this.comments) {
								if (this.comments[c].id == originId) {
									let replyIndex = this.comments[c].children.findIndex(arr=>arr.id==this.replyEditId);
									this.comments[c].children[replyIndex] = response.data.data;
									this.replyEditId = null;
									
								}
							}
						}).catch((err) => {
							this.$error({ content: err.errMsg }).then(() => {});
						});

					}
		},
				invalidCountImg() {
			if (this.isComment && this.form.images.length >= 5) {
				this.$alert({
					content: this.$t("1469"),
					accept: this.$t("1470")
				});
				return false;
			} else {
				if(this.replyImg.length >= 5) {
					this.$alert({
						content: this.$t("1469"),
						accept: this.$t("1470")
					});
					return false;
				}
				
			}
			return true;
		},
				resetCommentForm() {
			this.form = {
				contents: null,
				images: [],
			};
			
		},
		openFileUpload(status) {
			this.isComment = status;
			document.getElementById("commentFileUpload").click();
		},
		resetVideo() {
			this.form.images = Array();
		},
		getPayerOption(img) {
			return {
				muted: true,
				language: "en",
				playbackRates: [0.7, 1.0, 1.5, 2.0],
				sources: [
				{
					type: img.contentType,
					src: img.resourceUri,
				},
				],
				height: 80,
				width: 80,
			};
		},
				close(){
			if(this.showPreview){
				this.showPreview = false;
			}
			else{
					let params = {
									title: this.$t('3394'),
									content: this.$t('3395'),
									accept: this.$t('3397'),
									cancel: this.$t('3396')
					}
					this.$confirm(params).then((res) => {
						this.temprorayDataSave();
						//this.submitAllStepResults(submitAllQuestionData, this.dataId);
					}).catch((error) => {
						console.log(error)
					})
			}
		},
		getType(contentType) {
			return contentType.split("/")[0];
		},
		resizeIt(str) {
			var elmnt = document.getElementById("comment_textarea");
			elmnt.style.height = 0;
			var scHeight = elmnt.scrollHeight;
			elmnt.style.height = scHeight+"px";
		},
		uploadFile(evt) {
			if (!evt.target.files[0]) return;
			if (!this.invalidCountImg()) return;

			this.$showLoading();
			checklistApi.upload(evt.target.files[0]).then((response) => {
				// check if Image need to add into reply or comment
				if (this.isComment) this.form.images.push(response.data.data[0]);
				else this.replyImg.push(response.data.data[0]);

				this.$hideLoading();
			}).catch((err) => {
					this.$hideLoading();
					this.$error({ content: err.errMsg }).then(() => {});
			});
		},
	}
}
</script>